var _filter, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 0.5,
    floodOpacity: 0.5,
    floodColor: "black"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    filter: "url(#shadow)",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    id: "path-1",
    cx: 15,
    cy: 15,
    r: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/close-copy",
    transform: "translate(9.150000, 9.150000)",
    fill: "#3365FF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "clear",
    points: "9.885 0 6 3.885 2.115 0 0 2.115 3.885 6 0 9.885 2.115 12 6 8.115 9.885 12 12 9.885 8.115 6 12 2.115"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.7e0675b001dc93ac98e7fa18e778dd45.svg";
export { ForwardRef as ReactComponent };